export default {
  zh: {
    forgetTitle: '找回密码',
    emailFind: '邮箱找回',
    emailFindDescribe: '请输入您的登陆电子邮箱，我们将向您发送一个链接重置您的密码',
    emailPlaceholder: '邮箱',
    emailHint: '请输入邮箱',
    phoneFind: '验证码找回',
    phonePlaceholder: '手机号',
    phoneHint: '请输入手机号',
    codePlaceholder: '验证码',
    codeHint: '请输入验证码',
    send: '发送验证码',
    again: '重新发送',
    pwPlaceholder: '新密码',
    passwordHint: '请输入新密码',
    affirmPwPlaceholder: '确认新密码',
    affirmPasswordHint: '请输入确认新密码',
    affirm: '确认修改',
    editSuccess: '修改成功'
  },
  en: {
    forgetTitle: 'Retrieve password',
    emailFind: 'Email',
    emailFindDescribe: 'Please enter your login email address and we will send you a link to reset your password',
    emailPlaceholder: 'Email',
    emailHint: 'Please enter email',
    phoneFind: 'Mobile Phone',
    phonePlaceholder: 'Mobile Phone',
    phoneHint: 'Please enter your mobile phone number',
    codePlaceholder: 'Verification code',
    codeHint: 'Please enter the verification code',
    send: 'Send',
    again: 'Send again',
    pwPlaceholder: 'New password',
    passwordHint: 'Please enter a new password',
    affirmPwPlaceholder: 'Confirm the new password',
    affirmPasswordHint: 'Please enter your new password again',
    affirm: 'Confirm',
    editSuccess: 'Modify successfully'
  }
}
